module.exports = __webpack_public_path__ + "media/images/countrysquared/ru-e280df573b6d51afd297b78856d03bbc.svg";